// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"4911bddc","710":"4911bddc"}[chunkId] + ".chunk.css";
};